import { INamedItem } from '~src/ts/ServerApi/types/resourceParts';

import { Request } from '../../../../httpClient/serverApi/requests/Request';

// contentType type can match any of the enum values from https://sourcegraph.prod.tableautools.com/teams/near/-/blob/workgroup/src/shared/interfaces/tab-domain-interfaces/src/com/tableausoftware/domain/content/ContentType.java#L76:42
export interface IGetContainerForContentParams {
  readonly contentId: string;
  readonly contentType: 'database' | 'table';
}

export interface IGetContainerForContentResult extends Omit<Required<INamedItem>, 'contents'> {
  readonly type: 'PERSONAL_SPACE' | 'PROJECT';
}

export class GetContainerForContentRequest extends Request<IGetContainerForContentParams, IGetContainerForContentResult> {
  constructor(params: IGetContainerForContentParams) {
    super('getContainerForContent', params);
  }
}